@if (isLoading) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <div class="settings-header-row">
    <span class="title">Billing</span>
  </div>
  <pdq-tabs-group class="billing-tabs" (onChange)="switchTab($event)" variant="underline">
    @for (tab of tabsData; track tab) {
      <pdq-tab [value]="tab.value" [active]="tab.active" [label]="tab.label"> </pdq-tab>
    }
  </pdq-tabs-group>
  <article class="content">
    @if (isActiveTab('overview')) {
      <app-billing-overview (switchToPlansPage)="switchTab('plans')"></app-billing-overview>
    }
    @if (isActiveTab('history')) {
      <app-billing-history></app-billing-history>
    }
    @if (isActiveTab('plans')) {
      <app-billing-plans></app-billing-plans>
    }
  </article>
}
